import { accessTokens } from 'api/accessTokenMgmt'

/**
 * Merge Devise Token Auth credentials into ActionCable subscription params so the server
 * can authenticate the subscriber (see ApplicationCable::Channel#verified_user_from_token).
 *
 * UserChannel / EventBusChannel now reject any subscription whose verified token user does
 * not match the requested user id — without this, a client could subscribe as any user and
 * receive their payment statuses, txids, and balances. Every UserChannel/EventBusChannel
 * subscription site must build its params through this helper, and so must QuestChannel /
 * AnswerChannel: a private thread's streams only admit a subscriber whose token can view it.
 */
export function withChannelAuth<T extends object>(
    params: T,
): T & { uid?: string; client?: string; 'access-token'?: string } {
    const tokens = accessTokens()
    return {
        ...params,
        uid: tokens?.uid,
        client: tokens?.client,
        'access-token': tokens?.['access-token'],
    }
}
